import { envVariables } from '@fabric-ui/utils';
import { gql } from 'graphql-request';

const postSamlResponse = (samlResponse: string, sfAuthenticationUrl: string): void => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = sfAuthenticationUrl;
  form.target = '_blank';

  const samlInput = document.createElement('input');
  samlInput.type = 'hidden';
  samlInput.name = 'SAMLResponse';
  samlInput.value = samlResponse;

  form.appendChild(samlInput);
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

const useSalesforceSupportPortal =
  ({ api, currentApp }: { api: any; currentApp: string }) =>
  () =>
    api(GET_SAML_ASSERTION_FOR_SALESFORCE, {
      options: { pagePath: window.location.href, currentApp },
    }).then(({ data }) => {
      const { getSamlAssertionForSFAuthentication: samlResponse } = data;

      if (!samlResponse) {
        console.error('could not generate saml response for Salesforce SSO authentication');
        return;
      }

      postSamlResponse(samlResponse, envVariables.VITE_SALESFORCE_ENDPOINT);
    });

const GET_SAML_ASSERTION_FOR_SALESFORCE = gql`
  query getSamlAssertionForSFAuthentication($pagePath: String!, $currentApp: String) {
    getSamlAssertionForSFAuthentication(pagePath: $pagePath, currentApp: $currentApp)
  }
`;

export default useSalesforceSupportPortal;
